export function isKorean(value) {
	let isKorean = false;
	if(value.match(".*[ㄱ-ㅎㅏ-ㅣ가-힣]+.*"))
		isKorean = true;
	return isKorean;
}

export function lpad(str, padLen, padStr) {
	if (padStr.length > padLen) {
		console.log("오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다");
		return str;
	}
	str += ""; // 문자로
	padStr += ""; // 문자로
	while (str.length < padLen)
		str = padStr + str;
	str = str.length >= padLen ? str.substring(0, padLen) : str;
	return str;
}

export function rpad(str, padLen, padStr) {
	if (padStr.length > padLen) {
		console.log("오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다");
		return str + "";
	}
	str += ""; // 문자로
	padStr += ""; // 문자로
	while (getTextLength(str) < padLen)
		str += padStr;
	str = getTextLength(str) >= padLen ? str.substring(0, padLen) : str;
	return str;
}

export function getTextLength(str) {
	let len = 0;
	for (let i = 0; i < str.length; i++) {
		if (escape(str.charAt(i)).length === 6) {
			len++;
		}
		len++
	}
	return len;
}

export function cutStr(str, start, size) {
	let i = 0;
	let lim = 0;
	let pos = 0;
	let beg = 0;
	let len = getTextLength(str);
	for (i = 0; pos < start; i++) {
		pos += (str.charCodeAt(i) > 128) ? 2 : 1;
	}
	beg = i;
	for (i = beg; i < len; i++) {
		lim += (str.charCodeAt(i) > 128) ? 2 : 1;
		if (lim > size) {
			break;
		}
	}
	return str.substring(beg, i);
}
